import React from 'react'

import PropTypes from 'prop-types'

import './processo.css'

const Processo = (props) => {
  return (
    <div className="processo-container1">
      <div className="processo-container2">
        <span className="processo-text1">{props.title}</span>
        <span className="processo-text2 Content">{props.text}</span>
      </div>
      <img
        alt={props.imageAlt}
        src={props.imageSrc}
        loading="eager"
        className="processo-image"
      />
    </div>
  )
}

Processo.defaultProps = {
  imageAlt: 'image',
  rootClassName: '',
  title: 'Title',
  text: 'Text',
  imageSrc: 'https://play.teleporthq.io/static/svg/default-img.svg',
}

Processo.propTypes = {
  imageAlt: PropTypes.string,
  rootClassName: PropTypes.string,
  title: PropTypes.string,
  text: PropTypes.string,
  imageSrc: PropTypes.string,
}

export default Processo
